import { useSuspenseQuery } from "@apollo/client/react";
import React from "react";

import { GetAdminDataDocument, type GetAdminDataQuery, type GetAdminDataQueryVariables } from "~/common/gqls";
import type { Role, UserSegment } from "~/common/types";

type ProductRole = {
  role: {
    id: string;
    name: string;
  };
};

type Product = {
  id: string;
  name: string;
  productRoles: ProductRole[];
};

type UserGroup = {
  id: string;
  name: string;
};

interface AdminDataContextInterface {
  products: Product[];
  roles: Role[];
  userSegments: UserSegment[];
  userGroups: UserGroup[];
}

const AdminDataContext = React.createContext<AdminDataContextInterface>({
  products: [],
  roles: [],
  userSegments: [],
  userGroups: [],
});

interface AdminDataProviderProps {
  children: React.ReactNode;
}

export const AdminDataProvider: React.FC<AdminDataProviderProps> = ({ children }) => {
  const { data } = useSuspenseQuery<GetAdminDataQuery, GetAdminDataQueryVariables>(GetAdminDataDocument);
  return <>{data && <AdminDataContext.Provider value={data}>{children}</AdminDataContext.Provider>}</>;
};

export const useAdminData = () => React.useContext(AdminDataContext);
